import MESSAGE_KEY from '../announcement-message-key';

export default {
  [MESSAGE_KEY.AGREE_ANNOUNCEMENT_BUTTON]: '同意并继续',
  [MESSAGE_KEY.DISAGREE_ANNOUNCEMENT_BUTTON]: '不同意',
  [MESSAGE_KEY.EXIT_BUTTON]: '仍不同意，退出登录',
  [MESSAGE_KEY.READ_AGAIN_BUTTON]: '返回查看',

  [MESSAGE_KEY.DISAGREE_ANNOUNCEMENT_TIPS]: '若您不同意上述内容，很遗憾我们将无法继续为您提供服务。',

  [MESSAGE_KEY.ANNOUNCEMENT_TITLE]: '用户个人信息保护说明',

  [MESSAGE_KEY.NETWORK_ERROR]: '网络繁忙，请稍后再试',
  [MESSAGE_KEY.GET_ANNOUNCEMENT_ERROR]: '无法获取系统公告',
};